var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 14.5,
    fill: "#35659C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2991_71433)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.807 24.8195C15.1207 24.8195 15.375 24.5652 15.375 24.2515V21.1375C15.375 20.8238 15.6293 20.5695 15.943 20.5695H19.057C19.3707 20.5695 19.625 20.8238 19.625 21.1375V24.2515C19.625 24.5652 19.8793 24.8195 20.193 24.8195H22.2445C22.5582 24.8195 22.8125 24.5652 22.8125 24.2515V17.95C22.8125 17.6363 23.0668 17.382 23.3805 17.382H24.4883C25.0128 17.382 25.257 16.7319 24.8623 16.3865L17.874 10.2717C17.6599 10.0844 17.3401 10.0844 17.126 10.2717L10.1377 16.3865C9.74296 16.7319 9.98722 17.382 10.5117 17.382H11.6195C11.9332 17.382 12.1875 17.6363 12.1875 17.95V24.2515C12.1875 24.5652 12.4418 24.8195 12.7555 24.8195H14.807Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2991_71433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealty);
export default __webpack_public_path__ + "static/media/realty.897af3fe1ca8b564b2840edecc5fec6a.svg";
export { ForwardRef as ReactComponent };